<template>
    <div class="ws_common_modal">
        <div class="ws_common_modal_body">
            <div class="ws_common_modal_header">
                <h2>Otp</h2>
                <span class="ws_common_modal_close">
                    <svg height="15px" viewBox="0 0 329.26933 329" width="15px" xmlns="http://www.w3.org/2000/svg" @click="closeVerifyOtpPopupMethod">
                        <g fill="#f44336">
                            <path
                                d="m21.339844 329.398438c-5.460938 0-10.925782-2.089844-15.082032-6.25-8.34375-8.339844-8.34375-21.824219 0-30.164063l286.589844-286.59375c8.339844-8.339844 21.824219-8.339844 30.164063 0 8.34375 8.339844 8.34375 21.824219 0 30.164063l-286.589844 286.59375c-4.183594 4.179687-9.621094 6.25-15.082031 6.25zm0 0">
                            </path>
                            <path
                                d="m307.929688 329.398438c-5.460938 0-10.921876-2.089844-15.082032-6.25l-286.589844-286.59375c-8.34375-8.339844-8.34375-21.824219 0-30.164063 8.339844-8.339844 21.820313-8.339844 30.164063 0l286.589844 286.59375c8.34375 8.339844 8.34375 21.824219 0 30.164063-4.160157 4.179687-9.621094 6.25-15.082031 6.25zm0 0">
                            </path>
                        </g>
                    </svg>
                </span>
            </div>
            <form @submit.prevent="validateBeforeVerifySubmit">
                <div class="form-group">
                    <div class="phone_number_field_box" style="max-width: 100px;">
                        <input autocomplete="off" name="otp" maxlength="6" type="tel" class="form-control" v-model="otp"
                            v-validate="{ required: true, min: 6 }">
                    </div>
                </div>
                <div class="text-right">
                    <button type="submit" class="btn btn-primary" :disabled="isSubmitting">Verify</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
/*eslint-disable */
import {
    bus
} from '@/main';
import toast from '@/services/toast';
export default {
    props: ['form'],
    name: 'otpVerifyPopup',
    components: {
    },
    data() {
        return {
            otp: '',
            isSubmitting: false
        };
    },
    mounted() {
    },
    methods: {
        closeVerifyOtpPopupMethod() {
            bus.$emit('verifyOtpPopupStateBus', false);
            document.body.classList.remove('body_right_scroll_remove');
        },
        validateBeforeVerifySubmit() {
            this.$validator.validate().then((result) => {
                if (result) {
                    this.$store.dispatch('faqRequestSumitAction', {
                        otp: this.otp,
                        email: this.form.email,
                        first_name: this.form.fname,
                        last_name: this.form.lname,
                        description: this.form.description
                    }).then((res) => {
                        toast.success(res.data.msg);
                        this.isSubmitting = false;
                        this.closeVerifyOtpPopupMethod();
                    }).catch((err) => {
                        toast.error(err.data.user_msg || err.data.msg);
                        this.isSubmitting = false;
                    })
                    return;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.ws_common_modal {
    background: linear-gradient(-30deg, rgba(37, 44, 84, 0.95), rgba(0, 0, 0, 0.95) 50%, rgba(38, 38, 38, 0.95) 0, rgba(44, 44, 84, 0.95));
    position: fixed;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 100px 20px 0px;
    z-index: 1000;


    .ws_common_modal_body {
        background: linear-gradient(-30deg, rgba(37, 44, 84, 1), rgba(0, 0, 0, 1) 50%, rgba(38, 38, 38, 1) 0, rgba(44, 44, 84, 1));
        width: 100%;
        border-radius: 10px;
        border: 1px solid rgba(93, 93, 93, .5);
        padding: 30px 15px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        color: #ffffff;
        box-shadow: 0px 0px 15px rgba(255, 213, 0, 0.2);
        position: relative;
        max-width: 400px;
        margin: 0 auto;

        .form-control {
            font-size: 16px;
            border-radius: 5px;
            padding: 25px 15px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            outline: none !important;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            color: #ffd400;
            background: rgba(255, 255, 255, 0.08);

            &:focus,
            &.active {
                border: 1px solid #ffd400;
            }

            &::placeholder,
            &::-webkit-input-placeholder,
            &::-moz-placeholder {
                color: rgba(255, 255, 255, 0.3);
            }

            &:focus::-webkit-input-placeholder {
                font-size: 0;
            }

            &:focus::-moz-placeholder {
                font-size: 0;
            }
        }

        .btn-primary {
            background: rgba(255, 255, 255, 0.1);
            color: #ffd400;
            font-size: 18px;
            min-width: 110px;
            min-height: 30px;
            border-radius: 4px;
            box-shadow: none !important;
            border: none !important;

            &:hover {
                background: #87cefa;
                color: #333;
            }
        }
    }

    .ws_common_modal_header {
        h2 {
            color: #ffec97;
            font-size: 20px;
            line-height: 1.2;
            margin-bottom: 10px;
        }

        .ws_common_modal_close {
            position: absolute;
            top: 5px;
            right: 8px;

            svg {
                cursor: pointer;

                &:hover path {
                    fill: #87cefa;
                }
            }
        }
    }
}
</style>